import { Dispatch } from "redux";

import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import axios from "axios";

import * as actions from "./actiontypes";
import * as models from "./model";
import { roomApi } from "./roomApi";

import { RoomAndDistanceResult, RoomAndDistanceFailedGeocodeResult } from "./model";

import { push } from "redux-little-router";

export type RoomAction =
      ({ type: typeof actions.LOAD_ROOMS_SUCCESS } & Payload<models.RoomListModel[]>)
    | ({ type: typeof actions.CREATE_ROOM_SUCCESS } & Payload<models.RoomDetailModel>)
    | ({ type: typeof actions.LOAD_ROOM_DETAIL_SUCCESS } & Payload<models.RoomDetailModel>)
    | ({ type: typeof actions.SAVE_ROOM_SUCCESS } & Payload<models.RoomDetailModel>)
    | ({ type: typeof actions.DELETE_ROOM_SUCCESS } & Payload<any>);

export const loadRoomsSuccess = (payload: models.RoomListModel[]): RoomAction => ({
    payload,
    type: actions.LOAD_ROOMS_SUCCESS
});

export const createRoomSuccess = (payload: models.RoomDetailModel): RoomAction => ({
    payload,
    type: actions.CREATE_ROOM_SUCCESS
});

export const saveRoomSuccess = (payload: models.RoomDetailModel): RoomAction => ({
    payload,
    type: actions.SAVE_ROOM_SUCCESS
});

export const deleteRoomSuccess = (id: any): RoomAction => ({
    payload: id,
    type: actions.DELETE_ROOM_SUCCESS
});

export function createRoom(room: models.RoomCreateUpdateModel, path: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.CREATE_ROOM, roomApi.create(room));
        dispatch(createRoomSuccess(result));
        dispatch(push(`${path}/${result.id}`, {}));
    };
}

export function saveRoom(id: string, room: models.RoomCreateUpdateModel, path?: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.SAVE_ROOM, roomApi.save(id, room));

        dispatch(saveRoomSuccess(result));
        if (path !== undefined) {
            dispatch(push(`${path}/${result.id}`, {}));
        }
    };
}

export function deleteRoom(id: any, path: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "deleteRoom", roomApi.delete(id));
        dispatch(deleteRoomSuccess(id));
        dispatch(push(`${path}`, {}));
    };
}

export function loadRooms(filter: models.RoomFilter) {
    return async (dispatch: Dispatch) => {
        try {
            const result = await loadAndTrack(dispatch, "loadRooms", roomApi.getAll(filter));
            dispatch(loadRoomsSuccess(result));
            return result;
        } catch (ex) {
            if (!(ex instanceof axios.Cancel)) { // eslint-disable-line import/no-named-as-default-member
                throw ex;
            }

            return [];
        }
    };
}

export function loadRoomsAndDistances(postcode: string, distance: number) {
    return async (dispatch: Dispatch): Promise<RoomAndDistanceResult | RoomAndDistanceFailedGeocodeResult | null> => {
        try {
            const result = await loadAndTrack(dispatch, "loadRoomsAndDistances", roomApi.getDistances(postcode, distance));
            return result;
        } catch (ex) {
            if (!(ex instanceof axios.Cancel)) { // eslint-disable-line import/no-named-as-default-member
                throw ex;
            }

            return null;
        }
    };
}

export const loadRoomDetailSuccess = (room: models.RoomDetailModel) => ({
    payload: room,
    type: actions.LOAD_ROOM_DETAIL_SUCCESS
});

export function loadRoomDetail({ roomId }: { roomId: string }) {
    return async (dispatch: Dispatch, getState: () => models.AppState) => {
        const room = getState().rooms.filter(c => c.id === roomId)[0];

        if (room === undefined
            || !("detailUpdated" in room)
            || room.detailUpdated === undefined
            || room.detailUpdated.isBefore(room.listUpdated)) {

            const action = room === undefined ? createRoomSuccess : loadRoomDetailSuccess;

            const result = await loadAndTrack(dispatch, "loadRoomDetail", roomApi.detail(roomId));
            dispatch(action(result));
        }
    };
}
